module.exports = __webpack_public_path__ + "img/detractoresPeople.2ee06113.svg";